import { ENVIRONMENT } from 'shared/constants'

export const getEnvironmentName = (environment: string | undefined): ENVIRONMENT => (environment === 'production' ? ENVIRONMENT.PROD : ENVIRONMENT.DEV)
